import { useState, useRef } from 'react';
import { useWizardNavigation } from './use-wizard';
import { StepContainer } from './step-container';
import { MessageCircle } from 'lucide-react';

function StepPhone() {
  const { searchParams, goNext, goBack, currentIndex, totalSteps } =
    useWizardNavigation();
  const [value, setValue] = useState(searchParams.get('telefono') || '');
  const inputRef = useRef<HTMLInputElement>(null);

  const isValid = /^09\d{7}$/.test(value);

  const handleNext = () => {
    if (isValid) goNext({ telefono: value });
  };

  const remaining = 9 - value.length;

  return (
    <StepContainer
      stepIndex={currentIndex}
      totalSteps={totalSteps}
      title="¿Cuál es tu teléfono?"
      description={
        <div className="flex items-start gap-3 bg-green-50 text-green-700 p-4 rounded-xl">
          <MessageCircle className="w-5 h-5 mt-0.5 flex-shrink-0" />
          <span className="text-sm leading-relaxed">
            Nos vamos a comunicar contigo por{' '}
            <strong>WhatsApp</strong> para confirmarte la inscripción y
            mantenerte al día con el torneo.
          </span>
        </div>
      }
      onBack={goBack}
      onNext={handleNext}
      nextDisabled={!isValid}
    >
      <div>
        <input
          ref={inputRef}
          autoFocus
          type="tel"
          value={value}
          onChange={(e) => {
            const v = e.target.value.replace(/\D/g, '').slice(0, 9);
            setValue(v);
          }}
          placeholder="091234567"
          inputMode="numeric"
          autoComplete="tel"
          className="w-full text-lg md:text-xl p-4 border-2 border-gray-200 rounded-xl focus:border-primary focus:ring-4 focus:ring-primary/10 outline-none transition-all tracking-wider"
          onKeyDown={(e) => e.key === 'Enter' && isValid && handleNext()}
        />
        <div className="mt-2 min-h-[1.5rem]">
          {value.length > 0 && value.length < 9 && (
            <p className="text-sm text-gray-400">
              {remaining} dígito{remaining !== 1 ? 's' : ''} restante
              {remaining !== 1 ? 's' : ''}
            </p>
          )}
          {value.length === 9 && !isValid && (
            <p className="text-sm text-orange-500">
              El número debe empezar con 09
            </p>
          )}
          {value.length === 0 && (
            <p className="text-sm text-gray-400">
              Formato: 09XXXXXXX (9 dígitos)
            </p>
          )}
        </div>
      </div>
    </StepContainer>
  );
}

export const route = {
  path: 'telefono',
  element: <StepPhone />,
};
